// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">
  <sub-header header="'Release loan by ' + \$ctrl.method | prettyEnum"></sub-header>
    <missing-access-warning
      missing-access="CST_DEPOSIT_ACCOUNT_READ"
      ng-if="\$ctrl.method === 'CREDIT_TO_ACCOUNT'">
    </missing-access-warning>

    <form-section">
      <form name="\$ctrl.releaseForm">
        <table class="table table--generate-row-ids">
          <tbody>
          <tr>
            <td></td>
            <td>Product Type:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.loan.loanType.productDefinition.productName"
                disabled
              />
            </td>
          </tr>

          <tr>
            <td></td>
            <td>MIS Group:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.misGroup"
                disabled
              />
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Loan Type:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.creationType"
                disabled
              />
            </td>
          </tr>

          <tr ng-if="\$ctrl.isRemadeLoan()">
            <td></td>
            <td>{{\$ctrl.remadeLoanLabel}} from:</td>
            <td>
              <div class="restructured-loans">
                <input ng-repeat="productNumber in \$ctrl.remadeProductNumbers"
                       ng-model="productNumber"
                       type="text"
                       disabled
                />
              </div>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Interest Rate:</td>
            <td>
              <glue-container append-percentage="true">
                <input
                  type="number"
                  ng-model="\$ctrl.loan.interestRate"
                  disabled
                />
              </glue-container>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>EIR:</td>
            <td>
              <glue-container append-percentage="true">
                <input
                  type="number"
                  ng-model="\$ctrl.loan.eirAnnual"
                  disabled
                />
              </glue-container>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Payment Interval:</td>
            <td>
              <input
                type="text"
                ng-model="\$ctrl.loan.paymentIntervalDefinition.name"
                disabled
              />
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Total Amortization number:</td>
            <td>
              <input
                type="number"
                ng-model="\$ctrl.loan.totalAmortizationNumber"
                disabled
              />
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Term:</td>
            <td>
              <input
                type="number"
                ng-model="\$ctrl.loan.term"
                disabled
              />
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Grant Date:</td>
            <td>
              <date ng-model="\$ctrl.loan.grantDate"
                    ng-disabled="true"></date>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Maturity Date:</td>
            <td>
              <date ng-model="\$ctrl.loan.maturityDate"
                    ng-disabled="true"></date>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>First Payment Date:</td>
            <td>
              <date ng-model="\$ctrl.loan.firstAmortizationDueDate"
                    ng-disabled="true"></date>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Principal:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.principalAmount"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.loan.uidLedger">
            <td></td>
            <td>UID amount deducted:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.uidLedger.totalUnearnedInterest"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.loan.loanType.collectAdvanceInterest">
            <td></td>
            <td>Advance interest:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.advanceInterestAmount"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isLoanRenewal()">
            <td></td>
            <td>Previous loan principal balance:</td>
            <td>
              <cash
                ng-model="\$ctrl.renewedLoan.principalBalance"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isLoanRenewal()">
            <td></td>
            <td>Previous loan interest balance:</td>
            <td>
              <cash
                ng-model="\$ctrl.renewedLoan.interestBalance"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isLoanRenewal()">
            <td></td>
            <td>Previous loan charges:</td>
            <td>
              <cash
                ng-model="\$ctrl.renewedLoanDetails.totalTerminationFees"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isLoanRenewal()">
            <td></td>
            <td>Previous loan waived amount:</td>
            <td>
              <cash
                ng-model="\$ctrl.renewedLoanDetails.totalWaivedAmount"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr>
            <td></td>
            <td>Charges deducted from loan:</td>
            <td>
              <cash
                ng-model="\$ctrl.totalFeesAndCharges"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.chargesAlreadyPaid">
            <td></td>
            <td>Charges not deducted from loan:</td>
            <td>
              <cash
                ng-model="\$ctrl.chargesAlreadyPaid"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <!-- If loan creation type is not CONSOLIDATION, Net Proceeds first before Total Outstanding Balance,
          else if CONSOLIDATED, Total Outstanding Balance first before Net Proceeds -->

          <tr ng-if="!\$ctrl.isConsolidatedLoan()">
            <td></td>
            <td>Net proceeds:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.releaseAmount"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isRemadeLoan()">
            <td></td>
            <td>Total outstanding balance:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.remadeLoanBalance"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isConsolidatedLoan()">
            <td></td>
            <td>Net proceeds:</td>
            <td>
              <cash
                ng-model="\$ctrl.loan.releaseAmount"
                ng-disabled="true"
              >
              </cash>
            </td>
          </tr>

          <tr ng-if="\$ctrl.isRestructuredLoan()">
            <td></td>
            <td>Excessive amount:</td>
            <td>
              <div class="glued-input flex">
                <cash value="\$ctrl.calculateExcessiveAmount()"
                      ng-disabled="true">
                </cash>
                <help title="Excessive amount will be used as a payment for the new loan."></help>
              </div>
            </td>
          </tr>

          <tr ng-if="\$ctrl.method === 'CREDIT_TO_ACCOUNT'">
            <td></td>
            <td>Credit to account:</td>
            <td>
              <account-select ng-required="true" query-field="'id'" value-field="'id'"
                              field-mapping="{accountGroup: null, accountGroupMaxLength: null, name: 'name'}"
                              options="\$ctrl.accounts" ng-model="\$ctrl.selectedAccount"></account-select>
            </td>
          </tr>

          <tr ng-if="\$ctrl.method === 'CHECK'">
            <td></td>
            <td>MICR number:</td>
            <td>
              <input
                required
                type="text"
                class="micr check-no"
                ng-model="\$ctrl.micrNumber"
                ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
                ui-mask-placeholder
                ui-options="{clearOnBlur: false}"
                ng-change="\$ctrl.onMicrNumberChange(\$ctrl.micrNumber)"
                maxlength="64"
                ng-disabled="\$ctrl.loan.checkPreparationId"/>
            </td>
          </tr>

          <tr ng-if="\$ctrl.method === 'CHECK'">
            <td></td>
            <td>Valid from:</td>
            <td>
              <date ng-model="\$ctrl.validFrom"
                    output-format="date"
                    ng-disabled="true">
              </date>
            </td>
          </tr>

          <tr ng-if="\$ctrl.method === 'CHECK'">
            <td></td>
            <td>
              Check account:
              <label ng-if="!\$ctrl.loan.checkPreparationId && \$ctrl.allowedDepositoryModes.includes('INTER_BRANCH')">
                <input type="checkbox" ng-model="\$ctrl.interbranch" ng-change="\$ctrl.filterCheckingAccounts()" ng-disabled="\$ctrl.allowedDepositoryModes.length === 1 && \$ctrl.allowedDepositoryModes.includes('INTER_BRANCH');"/>
                Interbranch
              </label>
            </td>
            <td>
              <selectize options="\$ctrl.checkingAccounts"
                         config="\$ctrl.selectConfig"
                         ng-model="\$ctrl.checkingAccountId"
                         ng-required="true"
                         ng-disabled="\$ctrl.loan.checkPreparationId">
              </selectize>
            </td>
          </tr>

          <tr ng-if="\$ctrl.method === 'GENERAL_LEDGER'">
            <td></td>
            <td>General ledger account:</td>
            <td>
              <account-select options="\$ctrl.ledgerAccounts" ng-model="\$ctrl.ledgerAccount"
                              value-field="'id'"
                              required>
              </account-select>
            </td>
          </tr>

          </tbody>
        </table>

        <div class="labelled-field">
          <label>Remarks</label>
          <input type="text" ng-model="\$ctrl.remarks">
        </div>

        <div class="summary-actions">
          <button
            type="button"
            class="misc-transaction__cancel btn btn-warning"
            ng-click="\$ctrl.cancelChanges()">
            Cancel
          </button>
          <button
            type="submit"
            class="misc-transaction__save btn btn-success"
            ng-disabled="\$ctrl.releaseForm.\$invalid"
            ng-click="\$ctrl.releaseLoan()">
            Release
          </button>
        </div>

      </form>
    </form-section>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/release/customer-loan-release.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;